import { render } from "./DashboardCard.vue?vue&type=template&id=e25c1566&scoped=true&lang=html"
import script from "./DashboardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardCard.vue?vue&type=script&setup=true&lang=js"

import "./DashboardCard.vue?vue&type=style&index=0&id=e25c1566&lang=css&scoped=true"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e25c1566"]])

export default __exports__